/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQueryVariables = {
    collectionId: string;
};
export type AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQueryResponse = {
    readonly node: {
        readonly name?: string;
        readonly items?: {
            readonly edges: ReadonlyArray<{
                readonly cursor: string | null;
                readonly node: {
                    readonly id: string;
                    readonly __typename: "DocumentTemplate";
                    readonly title?: string;
                    readonly description?: string | null;
                    readonly color?: string | null;
                    readonly props?: unknown | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery = {
    readonly response: AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQueryResponse;
    readonly variables: AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQueryVariables;
};



/*
query AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery(
  $collectionId: ID!
) {
  node(id: $collectionId) {
    __typename
    ... on Collection {
      name
      items(first: 100) {
        edges {
          cursor
          node {
            __typename
            id
            ... on DocumentTemplate {
              __typename
              id
              title
              description
              color
              props
            }
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "props",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "CollectionItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/)
                                                            ],
                                                            "type": "DocumentTemplate",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "items(first:100)"
                                }
                            ],
                            "type": "Collection",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "CollectionItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/)
                                                            ],
                                                            "type": "DocumentTemplate",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "items(first:100)"
                                }
                            ],
                            "type": "Collection",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2342b89df8517042a9cd172468545c19",
            "id": null,
            "metadata": {},
            "name": "AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery",
            "operationKind": "query",
            "text": "query AppDokgeneratorWorkflowsEmploymentContractHessenmetallv1TypeStepQuery(\n  $collectionId: ID!\n) {\n  node(id: $collectionId) {\n    __typename\n    ... on Collection {\n      name\n      items(first: 100) {\n        edges {\n          cursor\n          node {\n            __typename\n            id\n            ... on DocumentTemplate {\n              __typename\n              id\n              title\n              description\n              color\n              props\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '1ce52b425119a9f6605b80f01e97daee';
export default node;
